import { FormikValues, useFormikContext } from 'formik';
import {
    PropsWithChildren, useState, useEffect,
} from 'react';
import { isHidden } from '../utils';
import { HidableFieldProps } from './types';

const HidableField = <T extends FormikValues>(props: PropsWithChildren<HidableFieldProps>) => {
    const {
        status: { hidden },
        values,
    } = useFormikContext<T>();
    const {
        name,
        children,
    } = props;

    const [isVisible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(false);
        setVisible(!isHidden(name, hidden, values));
    }, [name, hidden, values]);

    return isVisible
        ? <>{children}</>
        : null;
};

export default HidableField;
